import React, { useState, useEffect } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Row } from 'reactstrap';
import isEmpty from 'lodash/isEmpty';
import { InView } from 'react-intersection-observer';

import { fetchMixedBundles } from 'Redux/ducks/algolia-calls';
import Backtotopbutton from 'Components/Utility/Mobile/Backtotopbutton';
import Breadcrumbs from 'Components/Utility/SEO/Breadcrumbs';
import CountdownTimer from 'Components/Utility/CountdownTimer';
import HitCard from 'Components/Cards/HitCard';
import messages from 'Containers/Bundle/BundleMessages';
import Meta from 'Components/Utility/SEO/Meta';
import SkeletonHitCard from 'Components/Cards/SkeletonHitCard';
import TakeOver from 'Components/Banner/TakeOver';

import 'Components/StaticSearch/StaticFilters.scss';
import 'Containers/Bundle/BundlesLandingPage.scss';

const BundlefestContainer = ({
  intl: { formatMessage },
}) => {
  const [cleanHits, setCleanHits] = useState([]);

  useEffect(() => {
    const loadBundles = async () => {
      setCleanHits([]);
      const hits = await fetchMixedBundles();
      if (Array.isArray(hits)) {
        setCleanHits(hits);
      }
    };

    loadBundles();
  }, []);

  const gameBundles = cleanHits.filter(hit => hit.display_type === 'bundle');

  const crumbs = [
    { label: formatMessage(messages.bundlefest_title), link: '/bundlefest' },
  ];

  // bundlefest 2022 code
  let nextBundleLive = '2022-05-23T15:00:00.000Z';
  let hasTimePassed = true;
  const bundleLaunchTimes = [
    '2022-05-24T15:00:00.000Z',
    '2022-05-25T15:00:00.000Z',
    '2022-05-26T15:00:00.000Z',
    '2022-05-27T14:00:00.000Z',
  ];

  bundleLaunchTimes.forEach((time) => {
    if (Date.now() <= Date.parse(time) && hasTimePassed) {
      nextBundleLive = time;
      hasTimePassed = false;
    }
  });

  return (
    <div className="bundle-landing-page">
      <Meta
        brandReverse
        title={formatMessage(messages.bundlefest_socialTitle)}
        description={formatMessage(messages.bundlefest_desc)}
        socialTitle={formatMessage(messages.bundlefest_socialTitle)}
        url="bundlefest"
        hits={cleanHits}
        pageType="CollectionPage"
      />

      <Breadcrumbs crumbs={crumbs} />

      <TakeOver appearsOn="bundles" />

      <div className="pt-5 container">
        <div className="title-container">
          <InView>
            {({ inView, ref }) =>
              <div ref={ref}>
                <h1>
                  <FormattedMessage id="bundlefest.header" defaultMessage="BundleFest 2022" />
                </h1>
                {!inView &&
                  <div className="d-block d-sm-none">
                    <Backtotopbutton />
                  </div>
                }
              </div>
            }
          </InView>
        </div>

        <p className="seo-blurb-text mb-4">
          <FormattedMessage
            id="bundlefest.bundlefestblurb"
            defaultMessage="BundleFest is Fanatical’s exclusive bundle promotion bringing you unmissable collections of games at prices so good you won’t believe your eyes! With amazing bundles launching over the week featuring iconic AAA franchises, top quality indie games and awesome savings on eBooks, software and more."
          />
        </p>

        {isEmpty(cleanHits) &&
          <Row>
            <SkeletonHitCard
              numberOfCards={24}
              xsSize={6}
              mdSize={6}
              lgSize={4}
            />
          </Row>
        }

        {!isEmpty(gameBundles) &&
          <React.Fragment>
            <div className="justify-content-between d-block d-md-flex mb-4">
              <h4>
                <FormattedMessage id="bundlefest.headlineacts" defaultMessage="Headline Acts" />
              </h4>
              <CountdownTimer bundleLaunchTimer value={Date.parse(nextBundleLive)} />
            </div>
            <Row>
              {gameBundles.slice(0, 3).map(hit =>
                <HitCard
                  key={Math.random()}
                  hit={hit}
                  xsSize={6}
                  mdSize={6}
                  lgSize={4}
                />,
              )}
            </Row>
          </React.Fragment>
        }

        {!isEmpty(gameBundles) &&
          <React.Fragment>
            <h4 className="mb-4">
              <FormattedMessage id="bundlefest.supportingacts" defaultMessage="Supporting Acts" />
            </h4>
            <Row>
              {gameBundles.slice(3).map(hit =>
                <HitCard
                  key={Math.random()}
                  hit={hit}
                  xsSize={6}
                  mdSize={6}
                  lgSize={3}
                  smSize={6}
                />,
              )}
            </Row>
          </React.Fragment>
        }
      </div>
    </div>
  );
};

export default injectIntl(BundlefestContainer);
